import COLOR from './color';

interface Status {
  [key: string]: string;
}

interface StatusColor {
  [key: string]: string;
}

const STATUS: Status = {
  'created': 'Created',
  'updated': 'Updated',
  'pending_broadcast': 'Pending Broadcast',
  'broadcasting': 'Broadcasting',
  'cancelled': 'Cancelled',
  'accepted': 'Accepted',
  'pending_pickup': 'Pending Pickup',
  'unsuccessful_pickup': 'Unsuccessful Pickup',
  'pickup_arriving': 'Pickup Arriving',
  'pending_delivery': 'Pending Delivery',
  'delivery_arriving': 'Delivery Arriving',
  'unsuccessful_delivery': 'Unsuccessful Delivery',
  'complete': 'Complete',
  'expired': 'Expired',
};

export const STATUS_DESCRIPTION: Status = {
  'created': 'Created',
  'updated': 'Updated',
  'pending_broadcast': 'Pending Broadcast',
  'broadcasting': 'Broadcasting',
  'cancelled': 'Cancelled',
  'accepted': 'Accepted',
  'pending_pickup': 'Pending Pickup',
  'unsuccessful_pickup': 'Unsuccessful Pickup',
  'pickup_arriving': 'Pickup Arriving',
  'pending_delivery': 'Pending Delivery',
  'delivery_arriving': 'Delivery Arriving',
  'unsuccessful_delivery': 'Unsuccessful Delivery',
  'complete': 'Complete',
  'expired': 'Expired',
};

export const STATUS_COLOR: StatusColor = {
  'created': COLOR.grayishBlue,
  'updated': COLOR.grayishBlue,
  'pending_broadcast': COLOR.blue,
  'broadcasting': COLOR.blue,
  'accepted': COLOR.blue,
  'cancelled': COLOR.red,
  'pending_pickup': COLOR.yellow,
  'unsuccessful_pickup': COLOR.red,
  'pickup_arriving': COLOR.yellow,
  'pending_delivery': COLOR.yellow,
  'delivery_arriving': COLOR.yellow,
  'unsuccessful_delivery': COLOR.red,
  'complete': COLOR.cyan,
  'expired': COLOR.rouge,
};

export const TaskEditableStatuses: string[] = [
  'pending_broadcast',
  'broadcasting',
  'accepted',
  'pending_pickup',
  'pickup_arriving',
  'pending_delivery',
];

export const ActiveOrderStatusStrings: string[] = [
  'created',
  'pending_broadcast',
  'broadcasting',
  'accepted',
  'pending_pickup',
  'pickup_arriving',
  'pending_delivery',
  'delivery_arriving',
];

export const PastOrderStatusStrings: string[] = [
  'expired',
  'complete',
  'cancelled',
  'unsuccessful_pickup',
  'unsuccessful_delivery',
];

export default STATUS;